module.exports = __webpack_public_path__ + "static/img/Freelance Robotics logo_no_motto.6ccfe9db.webp";